module.exports = __webpack_public_path__ + "static/22_tat6-30a07f71624ff9adb5a0068d093ec76d.jpg";